import "./main-title.css"

export default function MainTitle({textTitle}){
    return(
        <h1 className="main-title">{textTitle}</h1>
    )
}